import React, { useState, useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import './PromoEmbed.css';

const PromoEmbed = () => {
    const [params] = useSearchParams();
    const location = useLocation();
    const [targetUrl, setTargetUrl] = useState(null);
    const [bannerUrl, setBannerUrl] = useState(null);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const target = params.get('target') || sessionStorage.getItem('target');
        const banner = params.get('banner') || sessionStorage.getItem('banner');

        if (target && banner) {
            setTargetUrl(target);
            setBannerUrl(banner);

            // Сохраняем в sessionStorage, если передано через URL
            if (params.get('target')) sessionStorage.setItem('target', target);
            if (params.get('banner')) sessionStorage.setItem('banner', banner);

            // Удаляем параметры из URL
            if (params.get('target') || params.get('banner')) {
                window.history.replaceState({}, '', location.pathname);
            }
        }
    }, [params, location.pathname]);

    if (!targetUrl || !bannerUrl) {
        return (
            <div className="container mt-5">
                <div className="alert alert-danger text-center">
                    Укажите параметры <strong>?target=</strong> и <strong>&banner=</strong> в URL.
                </div>
            </div>
        );
    }

    return (
        <div className="d-flex flex-column vh-100 position-relative">
            <iframe
                src={targetUrl}
                title="Target"
                className="flex-grow-1 border-0"
            />
            {isVisible && (
                <div className="promo-embed-banner bg-dark text-white px-4 py-3 d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                        <span className="fs-4">🚀</span>
                        <div>
                            <h6 className="mb-0">Уникальный контент здесь!</h6>
                            <small>Нажми, чтобы узнать подробнее</small>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <a
                            href={bannerUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-warning btn-sm"
                        >
                            Перейти
                        </a>
                        <button
                            className="btn btn-outline-light btn-sm"
                            onClick={() => setIsVisible(false)}
                        >
                            ✖
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PromoEmbed;
